const PRIMARY = "#2563eb";

interface Action {
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary";
}

interface Props {
  icon: string;
  title: string;
  description: string;
  actions?: Action[];
  compact?: boolean;
  iconColor?: string;
}

export default function EmptyState({
  icon,
  title,
  description,
  actions = [],
  compact = false,
  iconColor = PRIMARY,
}: Props) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center max-w-xs mx-auto ${
        compact ? "py-12 gap-3" : "py-20 gap-4"
      }`}
    >
      <div
        className={`flex items-center justify-center rounded-2xl ${
          compact ? "w-12 h-12" : "w-16 h-16"
        }`}
        style={{ backgroundColor: `${iconColor}18` }}
      >
        <i
          className={`${icon} ${compact ? "text-2xl" : "text-3xl"}`}
          style={{ color: iconColor }}
        ></i>
      </div>

      <div>
        <h3
          className={`text-[#0f172a] font-semibold mb-1.5 ${
            compact ? "text-sm" : "text-base"
          }`}
        >
          {title}
        </h3>
        <p
          className={`text-[#0f172a]/40 leading-relaxed ${
            compact ? "text-xs" : "text-sm"
          }`}
        >
          {description}
        </p>
      </div>

      {actions.length > 0 && (
        <div className="flex items-center gap-2 mt-1 flex-wrap justify-center">
          {actions.map((action, idx) => (
            <button
              key={idx}
              onClick={action.onClick}
              className={`flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                action.variant === "secondary"
                  ? "bg-slate-100 hover:bg-slate-100 text-[#0f172a]/70"
                  : "text-black"
              }`}
              style={
                action.variant !== "secondary"
                  ? { backgroundColor: PRIMARY }
                  : undefined
              }
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
